/**
 * Sidebar Initialization
 * Loads user data and advice center info into sidebar elements
 */

(function () {
  'use strict';

  // Run on all secured pages
  if (!window.location.pathname.startsWith('/secure/user/')) {
    return
  }

  const user = JSON.parse(localStorage.getItem("user"))

  $(document).ready(function () {
    loadSidebarData()
    loadAdviceCenterData()
  })

  function loadSidebarData() {
    if (user && user.user && user.user.attributes) {
      const attrs = user.user.attributes
      const bstText = (attrs.bstdNumber && attrs.bstNumber)
        ? (attrs.bstdNumber + '-' + attrs.bstNumber)
        : (attrs.bstNumber || '')
      const memberText = attrs.memberNumber ? ('Mitglieds-Nr.: ' + attrs.memberNumber) : ''

      // Desktop + Mobile befüllen
      ;['', 'mobile-'].forEach(function (prefix) {
        $('#' + prefix + 'sidebarBstNumber').html(bstText)
        $('#' + prefix + 'sidebarMemberNumber').html(memberText)
      })
    }
  }

  function loadAdviceCenterData() {
    
    console.log('Sidebar: Loading advice center data...')
    $.ajax({
      method: 'POST',
      url: '/cockpit/getadvicecenter',
      global: false, // Prevent global error handler
      data: {}  // No jwtToken parameter needed - uses Authorization header
    }).then(function(result) {
      console.log('Sidebar: Advice center response:', result)
      console.log('Sidebar: Full response structure:', JSON.stringify(result, null, 2))
      
      // Antwort ist ein single item, nicht ein Array
      if (result.success && result.data) {
        // Robuste Extraktion der Daten - handle verschiedene Strukturen
        let adviceCenter = null
        
        // JSON:API Format: { data: { data: { attributes, links } } }
        if (result.data.data) {
          adviceCenter = result.data.data
        }
        // Direktes Format: { data: { attributes, links } }
        else if (result.data.attributes) {
          adviceCenter = result.data
        }
        // Fallback: data ist bereits das Objekt
        else {
          adviceCenter = result.data
        }
        
        const attrs = adviceCenter.attributes || adviceCenter || {}
        const links = adviceCenter.links || {}
        
        console.log('Sidebar: Extracted attributes:', attrs)
        console.log('Sidebar: Extracted links:', links)
        
        // Leitung - Block nur anzeigen wenn BEIDE Teile (Vorname UND Nachname) vorhanden
        const leaderText = (attrs.bstLeaderFirstName && attrs.bstLeaderLastName &&
            attrs.bstLeaderFirstName.trim() !== '' && attrs.bstLeaderLastName.trim() !== '')
          ? (attrs.bstLeaderFirstName + ' ' + attrs.bstLeaderLastName)
          : ''
        const showLeader = leaderText !== ''
        ;['', 'mobile-'].forEach(function (prefix) {
          $('#' + prefix + 'sidebarLeader').html(leaderText)
          $('#' + prefix + 'sidebar-advice-details').find('.profile-name').toggle(showLeader)
        })
        
        // Adresse - mit Google Maps Link
        const addressParts = []
        if (attrs.street) addressParts.push(attrs.street)
        if (attrs.zip && attrs.city) {
          addressParts.push(attrs.zip + ' ' + attrs.city)
        } else if (attrs.city) {
          addressParts.push(attrs.city)
        }
        if (attrs.cityPart) addressParts.push('(' + attrs.cityPart + ')')
        
        const addressHtml = addressParts.length > 0
          ? (function () {
              const addressText = addressParts.join(', ')
              const addressDisplay = addressParts.join('<br>')
              const mapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addressText)
              return '<a href="' + mapsUrl + '" target="_blank" rel="noopener" title="Route in Google Maps öffnen">' + addressDisplay + '</a>'
            })()
          : null
        const phoneHtml = attrs.phoneNumber
          ? '<a href="tel:' + attrs.phoneNumber.replace(/\s/g, '') + '">' + attrs.phoneNumber + '</a>'
          : null
        const mobileHtml = attrs.mobile
          ? '<a href="tel:' + attrs.mobile.replace(/\s/g, '') + '">' + attrs.mobile + '</a>'
          : null
        const websiteUrl = attrs.website ? (attrs.website.startsWith('http') ? attrs.website : 'https://' + attrs.website) : null
        const hoursHtml = attrs.openingHours ? attrs.openingHours.replace(/\n/g, '<br>') : null
        const absenceFormatted = attrs.absenceEndDate
          ? new Date(attrs.absenceEndDate).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
          : null
        const isAvailable = !attrs.absenceEndDate
        const portraitSrc = links.portrait || (user && user.thumb ? 'data:image/jpeg;base64,' + user.thumb : null)

        ;['', 'mobile-'].forEach(function (prefix) {
          if (addressHtml) $('#' + prefix + 'sidebarAddress').html(addressHtml)
          if (phoneHtml) $('#' + prefix + 'sidebarPhone').html(phoneHtml)
          if (mobileHtml) {
            $('#' + prefix + 'sidebarMobile').html(mobileHtml)
            $('#' + prefix + 'sidebarMobileGroup').show()
          }
          if (websiteUrl) {
            $('#' + prefix + 'sidebarWebsite').attr('href', websiteUrl).html(attrs.website)
            $('#' + prefix + 'sidebarWebsiteGroup').show()
          }
          if (attrs.calenderLink) {
            $('#' + prefix + 'sidebarCalendar').attr('data-booking-url', attrs.calenderLink)
            $('#' + prefix + 'sidebarCalendarGroup').show()
          }
          if (hoursHtml) {
            $('#' + prefix + 'sidebarHours').html(hoursHtml)
            $('#' + prefix + 'sidebarHoursGroup').show()
          }
          if (absenceFormatted) {
            $('#' + prefix + 'sidebarAbsence').html(absenceFormatted)
            $('#' + prefix + 'sidebarAbsenceGroup').show()
          }
          $('#' + prefix + 'sidebarPortraitWrapper')
            .removeClass(isAvailable ? 'status-absent' : 'status-available')
            .addClass(isAvailable ? 'status-available' : 'status-absent')
            .attr('title', isAvailable ? 'Ihre Beratungsstelle ist zu den angegebenen Bürozeiten erreichbar.' : 'Abwesend')
          $('#' + prefix + 'sidebarPortrait').attr('title', isAvailable ? 'Ihre Beratungsstelle ist zu den angegebenen Bürozeiten erreichbar.' : 'Abwesend')
          if (portraitSrc) {
            $('#' + prefix + 'sidebarPortrait').attr('src', portraitSrc)
            $('#' + prefix + 'sidebarPortraitContainer').show()
          } else {
            $('#' + prefix + 'sidebarPortraitContainer').hide()
          }
          $('#' + prefix + 'sidebar-advice-details').show()
        })

        console.log('Sidebar: Advice center details displayed (desktop + mobile)')
      } else {
        console.warn('Sidebar: No advice center data in response')
      }
    }).catch(function(err) {
      // Handle auth errors (401/403) if handleAuthError is available
      if (typeof handleAuthError === 'function' && handleAuthError(err, false)) {
        return // Will redirect to login
      }
      // Only log non-auth errors
      console.error('Sidebar: Error loading advice center data:', err)
      if (err.responseJSON) {
        console.error('Sidebar: Error details:', err.responseJSON)
      }
    })
  }
})()
